import type { CommandStep } from "app/lib/pipeline";
import Emojify from "app/components/shared/Emojify";

interface Props {
  data: CommandStep;
  dockerImage?: string;
}

const Docker = ({ image }: { image: string }) => {
  return (
    <div className="flex flex-row items-center gap-2 bg-[rgba(0,0,0,0.05)] px-3 py-2 text-[0.75rem] text-charcoal-400">
      <Emojify className="text-[1rem]" text=":docker:" />
      <span className="inline-block font-mono">{image}</span>
    </div>
  );
};

export default function Commands({ data: { commandScript }, dockerImage }: Props) {
  if (!commandScript) {
    return null;
  }

  const commands = commandScript.split("\n");

  return (
    <div className="overflow-hidden rounded-lg border border-parsnip-400 bg-parsnip-100">
      {dockerImage && <Docker image={dockerImage} />}

      <code className="no-scrollbar relative flex flex-col gap-2 overflow-x-auto py-3 text-xs text-charcoal-700">
        {commands.map((command) => (
          <span className="relative flex gap-3 px-3" key={command}>
            <span className="pointer-events-none inline-block text-gray-600" aria-hidden="true">
              $
            </span>
            <span className="inline-block whitespace-nowrap">{command}</span>
          </span>
        ))}
      </code>
    </div>
  );
}
